<template>
  <div class="list">
    <el-form :model="dioForm" label-width="140px">
      <el-row>
        <el-col v-for="item in QueryData" :key="item.key" :span="8">
          <template v-if="item.content || item.content === 0">
            <el-form-item :label="$t(item.text)" :rules="item.rules">
              <span>{{ item.content }}</span>
            </el-form-item>
          </template>
        </el-col>
        <template v-if="detailData">
          <template
            v-if="detailData.sensor.type === 7 || detailData.sensor.type === 8"
          >
            <GenTwoTempConfig
              :is-click-config="true"
              :span="8"
              ref="genTwoTempConfig"
              :dio-form="detailData.appConfig"
            ></GenTwoTempConfig>
          </template>

          <template
            v-if="detailData.sensor.type === 9 || detailData.sensor.type === 10"
          >
            <FourGTempConfig
              :span="8"
              :is-click-config="true"
              :dio-form="detailData.appConfig"
            >
            </FourGTempConfig>
          </template>
        </template>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import GenTwoTempConfig from '@/pages/equipment/sensor/components/sensor/cionfig/children/device/GenTwoTempConfig/GenTwoTempConfig.vue'
import FourGTempConfig from '@/pages/equipment/sensor/components/sensor/cionfig/children/device/FourGTempConfig/FourGTempConfig.vue'

export default {
  components: {
    FourGTempConfig,
    GenTwoTempConfig
  },
  props: ['QueryData', 'detailData'],
  data () {
    return {
      dioForm: {}
    }
  },
  created () {
    console.log('QueryData=',this.QueryData)
  }
}
</script>

<style lang="scss" scoped>
.list {
  flex: 1;
}
</style>
